module.exports = __webpack_public_path__ + "static/media/successIcon.f78d94f1.svg";